<template>
  <v-dialog :value="value" persistent max-width="700px" scrollable>
    <nv-form title="Discoveries" save-text="OK" @cancel="formCancel" @nv-submit="formCancel">
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Media URL</th>
            <th class="text-left">Site URL</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in discoveries" :key="d.id">
            <td class="text-break">{{ d.media_url }}</td>
            <td class="text-break">
              <span v-if="d.site_urls && d.site_urls.length">
                {{ d.site_urls.join(', ') }}
              </span>
              <span v-else>N/A</span>
            </td>
          </tr>
          <tr v-if="!discoveries.length">
            <td colspan="2">
              <v-progress-linear v-if="loading" indeterminate />
              <span v-else>No discoveries found</span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </nv-form>
  </v-dialog>
</template>

<script>
import HTTP from '@/api/ant';
import { FormMixin } from '@nielsen-media/ui-toolkit-vue';

export default {
  mixins: [FormMixin],
  props: {
    proposalId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    discoveries: [],
    loading: false,
  }),
  methods: {
    formReady() {
      this.discoveries = [];
      if (this.proposalId) {
        this.loading = true;
        HTTP.get(`/video/proposals/rule/${this.proposalId}/discoveries`)
          .then(({ data }) => {
            this.discoveries = data;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
